import { http } from '@pendo/http';

export function fetchDashboards (params = {}) {
    return http.get('/api/s/_SID_/dashboard', { params }).then((res) => res.data);
}

export function fetchDashboard (id) {
    return http.get(`/api/s/_SID_/dashboard/${id}`).then((res) => res.data);
}

export function createDashboard (newDashboard) {
    return http.post('/api/s/_SID_/dashboard', newDashboard).then((res) => res.data);
}

export function deleteDashboard (dashboardId) {
    return http.delete(`/api/s/_SID_/dashboard/${dashboardId}`);
}

export function fetchDashboardPermissions (dashboardId) {
    return http.get(`/api/s/_SID_/dashboard/${dashboardId}/share`).then((res) => res.data);
}

export function shareDashboardWithUsers (dashboardId, params) {
    return http.post(`/api/s/_SID_/dashboard/${dashboardId}/share/user`, params).then((res) => res.data);
}

export function updateDashboardUserPermissions (dashboardId, userId, permission) {
    return http
        .patch(`/api/s/_SID_/dashboard/${dashboardId}/share/user/${userId}`, { permission })
        .then((res) => res.data);
}

export function updateDashboardSubPermissions (dashboardId, permission) {
    return http
        .patch(`/api/s/_SID_/dashboard/${dashboardId}/share/subscription`, { permission })
        .then((res) => res.data);
}

export function unshareUserFromDashboard (dashboardId, userId) {
    return http.delete(`/api/s/_SID_/dashboard/${dashboardId}/share/user/${userId}`);
}

export function fetchSharedDashboard (dashboardId) {
    return http.get(`/api/s/_SID_/dashboard/share/${dashboardId}`).then((res) => res.data);
}

export function addSharedDashboard (dashboardId) {
    return http.post('/api/s/_SID_/dashboard/share', { id: dashboardId }).then((res) => res.data);
}

export function updateDashboard (dashboard) {
    return http.put(`/api/s/_SID_/dashboard/${dashboard.id}`, dashboard).then((res) => res.data);
}
